import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import StackupHeading from '../components/shared/heading';
import Breadcrumbs from '../components/breadcrumbs';
// import ApplesToOrangesNotice from '../components/apples-to-oranges-notice';
import NavigationBar from '../components/navigation-bar';
import Timestamp from '../../../shared/library/timestamp';
import {NAVBAR_HEIGHT, PAGE_WIDTH} from '../../../shared/style/dimensions';
import {WHITE} from '../../../shared/style/colors';
import {GridItem} from '../components/shared/render';
import RenderToolCard from '../components/tool-card/render';
import GetAdviceButton from '../components/buttons/get-advice';

const Header = glamorous.div({
  width: PAGE_WIDTH,
  paddingTop: 10
});

const Row = glamorous.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});

const NAV_BAR_HEIGHT = 90;
const TOOL_CARD_STICKY_HEIGHT = 72;
const GRID_WIDTH = 860;

const StickyToolBar = glamorous.div(
  {
    marginTop: -TOOL_CARD_STICKY_HEIGHT,
    position: 'sticky',
    top: NAV_BAR_HEIGHT + NAVBAR_HEIGHT,
    width: '100%',
    boxShadow: '0 2px 4px 0 rgba(194, 194, 194, 0.5)',
    background: WHITE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: TOOL_CARD_STICKY_HEIGHT,
    transition: 'opacity 300ms ease',
    '>div': {
      width: PAGE_WIDTH,
      display: 'flex',
      '>div': {
        width: GRID_WIDTH,
        display: 'grid',
        gridTemplateColumns: `${GRID_WIDTH / 3}px ${GRID_WIDTH / 3}px ${GRID_WIDTH / 3}px`
      }
    }
  },
  ({isStuck}) => ({
    opacity: isStuck ? 1 : 0,
    pointerEvents: isStuck ? 'inherit' : 'none',
    zIndex: isStuck ? 1001 : 100
  })
);

const Heading = ({
  stackup,
  tools,
  stickyRef,
  removeAfterCons,
  removeAfterAlternatives,
  showJobs,
  jobsCount,
  showDecisions,
  showPros,
  showCons,
  showAlternativeTools,
  showIntegrations,
  showPosts,
  isStuck,
  navigate,
  contactEnabledTools,
  stackupPath,
  tooltip,
  currentUser,
  privateMode,
  userId,
  setOpenAdviceModal,
  setSignupAction,
  toolsLoaded
}) => {
  return (
    <>
      {/* {stackup && stackup.applesToOranges && <ApplesToOrangesNotice tool={tools[0]} />} */}

      <Header>
        <Row>
          <Breadcrumbs tool={tools[0]} />
          {stackup && stackup.seoUpdatedAt && (
            <Timestamp text="UPDATED" date={stackup.seoUpdatedAt} isDate={false} />
          )}
        </Row>
        <StackupHeading tools={tools} tool={tools[0]} toolsLoaded={toolsLoaded} />
      </Header>

      <NavigationBar
        ref={stickyRef}
        showJobs={removeAfterCons && removeAfterAlternatives && showJobs}
        jobsCount={jobsCount}
        showDecisions={showDecisions}
        showProsCons={showPros || showCons}
        showAlternativeTools={removeAfterCons && showAlternativeTools}
        showIntegrations={removeAfterCons && showIntegrations}
        showPosts={showPosts && removeAfterCons && removeAfterAlternatives}
        showDescription={removeAfterCons && removeAfterAlternatives}
        showStats={removeAfterCons && removeAfterAlternatives}
      />

      <StickyToolBar isStuck={isStuck}>
        <div>
          <div>
            <GridItem style={{border: 0, padding: '0 10px 0 10px'}}>
              <RenderToolCard
                tools={tools}
                index={0}
                minimal={true}
                navigate={navigate}
                focus={isStuck}
                onAddClick={null}
                contactEnabledTools={contactEnabledTools}
                stackupPath={stackupPath}
                tooltip={tooltip}
                userIsAdmin={currentUser && currentUser.amIAdmin}
                triggerEvent={false}
                emptySpaceComponent={
                  privateMode ? (
                    false
                  ) : (
                    <GetAdviceButton
                      userId={userId}
                      setOpenAdviceModal={setOpenAdviceModal}
                      setSignupAction={setSignupAction}
                      navigate={navigate}
                    />
                  )
                }
              />
            </GridItem>
            <GridItem style={{border: 0, padding: '0 10px 0 10px'}}>
              <RenderToolCard
                tools={tools}
                index={1}
                minimal={true}
                navigate={navigate}
                focus={isStuck}
                onAddClick={null}
                contactEnabledTools={contactEnabledTools}
                stackupPath={stackupPath}
                tooltip={tooltip}
                userIsAdmin={currentUser && currentUser.amIAdmin}
                triggerEvent={false}
                emptySpaceComponent={
                  privateMode ? (
                    false
                  ) : (
                    <GetAdviceButton
                      userId={userId}
                      setOpenAdviceModal={setOpenAdviceModal}
                      setSignupAction={setSignupAction}
                      navigate={navigate}
                    />
                  )
                }
              />
            </GridItem>
            <GridItem style={{border: 0, padding: '0 10px 0 10px'}}>
              <RenderToolCard
                tools={tools}
                index={2}
                minimal={true}
                navigate={navigate}
                focus={isStuck}
                onAddClick={null}
                contactEnabledTools={contactEnabledTools}
                stackupPath={stackupPath}
                tooltip={tooltip}
                userIsAdmin={currentUser && currentUser.amIAdmin}
                triggerEvent={false}
                emptySpaceComponent={
                  privateMode ? (
                    false
                  ) : (
                    <GetAdviceButton
                      userId={userId}
                      setOpenAdviceModal={setOpenAdviceModal}
                      setSignupAction={setSignupAction}
                      navigate={navigate}
                    />
                  )
                }
              />
            </GridItem>
          </div>
        </div>
      </StickyToolBar>
    </>
  );
};

Heading.propTypes = {
  stackup: PropTypes.object,
  tools: PropTypes.array,
  stickyRef: PropTypes.any,
  removeAfterCons: PropTypes.bool,
  removeAfterAlternatives: PropTypes.bool,
  showJobs: PropTypes.bool,
  jobsCount: PropTypes.number,
  showDecisions: PropTypes.bool,
  showPros: PropTypes.bool,
  showCons: PropTypes.bool,
  showAlternativeTools: PropTypes.bool,
  showIntegrations: PropTypes.bool,
  showPosts: PropTypes.bool,
  isStuck: PropTypes.any,
  navigate: PropTypes.func,
  contactEnabledTools: PropTypes.any,
  stackupPath: PropTypes.any,
  tooltip: PropTypes.bool,
  currentUser: PropTypes.object,
  privateMode: PropTypes.object,
  userId: PropTypes.any,
  setOpenAdviceModal: PropTypes.func,
  setSignupAction: PropTypes.func,
  toolsLoaded: PropTypes.bool
};

export default Heading;
